import React, { Fragment, useEffect, useRef, useState } from "react";
import BannerSec from "../restaurent/bannerSec/BannerSec";
import { apiData } from "../../../actions";
import DataLoader from "../../../Utils/DataLoader";
import { Link } from "react-router-dom";
import { UsePlaceAuth } from "../../../AppContext/AppContext";
import OwlCarousel from 'react-owl-carousel';
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { _Deals_ } from '../../../Redux/Action/Action';
import { Modal } from "react-bootstrap";
import SpcificPageModal from "../../Modals/SpcificPageModal";
import { toast } from "react-toastify";


function Deals() {
  const BtnMore = useRef(null);
  const [dealsData, setDealsData] = useState([]);
  const [inclusiveScript, setInclusiveScript] = useState("");
  const [singleData, setSingleData] = useState("");
  const [seeMoreModal, setSeeMoreModal] = useState(false);
  const [loadMoreLoader, setLoadMoreLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const { dealsTabActive, setDealsTabActive } = UsePlaceAuth();
  const place = useSelector(state => state.place);
  const dispatch = useDispatch();
  const GetInclusiveDeals = async () => {
    let payload = {
      city: place,
      limit: 20,
    };
    let apiRes = await apiData.inclusiveDeals(payload);
    if (apiRes?.status >= 200 && apiRes?.status <= 399) {
      setDealsData(
        apiRes?.data?.data?.tourSlider
      );
    }
    if (apiRes?.status >= 400 && apiRes?.status <= 500) {
      console.log("error");
    }
  };
  const GetInclusiveDealsScript = async () => {
    let payload = {
      city: place,
    };
    let apiRes = await apiData.inclusiveDeals(payload);
    if (apiRes?.status >= 200 && apiRes?.status <= 399) {
      // Fix: Check if getYourGuide[0]?.content exists before split
      const getYourGuideArr = apiRes?.data?.data?.getYourGuide;
      if (Array.isArray(getYourGuideArr) && getYourGuideArr[0]?.content) {
        setInclusiveScript(getYourGuideArr[0].content.split('"')[1]);
      } else {
        setInclusiveScript("");
      }
    }
    if (apiRes?.status >= 400 && apiRes?.status <= 500) {
      console.log("error");
    }
  };
  const GetTourTravel = async () => {
    let payload = {
      city: place,
    };
    let apiRes = await apiData.toursTravelAll(payload);
    if (apiRes?.status >= 200 && apiRes?.status <= 399) {
      // Fix: Only set singleData if the expected string is present
      const data = apiRes?.data?.data;
      if (typeof data === 'string' && data.includes('"')) {
        setSingleData(data);
      } else {
        setSingleData("");
      }
    } else {
      setSingleData("");
    }
  };
  const handleSeeAllClick = async () => {
    setLoadMoreLoader(true);
    setSeeMoreModal(true);

    setTimeout(() => {
      const container = document.getElementById("InclusiveScript");
      container.innerHTML = "";

      if (inclusiveScript) {
        const script = document.createElement("script");
        script.src = inclusiveScript;

        script.onerror = () => {
          container.innerHTML = `<div class="text-center text-danger font-weight-bold p-4">Data Not Found</div>`;
        };

        container.appendChild(script);
      } else {
        container.innerHTML = `<div class="text-center text-danger font-weight-bold p-4">Data Not Found</div>`;
      }

      setLoadMoreLoader(false);
    }, 1000);
  };

  useEffect(() => {
    const container = document.getElementById("singleData");
    if (!container) return;

    const fetchAllData = async () => {
      // Clear container
      container.innerHTML = "";

      // Start loader once
      setLoader(true);

      // Load script from singleData
      if (singleData) {
        // Fix: Check if singleData is a string and contains '"'
        let scriptSrc = '';
        if (typeof singleData === 'string' && singleData.includes('"')) {
          scriptSrc = singleData?.split('"')[1];
        }
        if (scriptSrc) {
          let script = document.createElement("script");
          script.src = scriptSrc;
          script.async = true;

          script.onload = () => {
            console.log("singleData script loaded");
          };

          script.onerror = () => {
            console.error("Failed to load singleData script");
          };

          container.appendChild(script);
        }
      }

      // Dispatch base deals action
      dispatch(_Deals_());
      setDealsTabActive("All");

      // Start all data calls in parallel
      try {
        await Promise.all([
          GetInclusiveDeals(),        // Don't setLoader inside this
          GetTourTravel(),            // Don't setLoader inside this
          new Promise(resolve => {
            setTimeout(async () => {
              await GetInclusiveDealsScript();  // Don't setLoader inside this
              resolve();
            }, 1500);
          })
        ]);
      } catch (err) {
        console.error("Error loading one of the APIs", err);
      }

      // End loader once everything is done
      setLoader(false);
    };

    fetchAllData();

    // Cleanup
    return () => {
      setLoader(false);
      if (container) container.innerHTML = "";
    };
  }, [place, dispatch, setDealsTabActive, singleData]);

  var settings1 = {
    items: 4,
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    nav: true,
    dots: false,
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 2
      },
      991: {
        items: 4
      }
    }
  };
  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  const [specificModal, setSpecificModal] = useState(false);
  useEffect(() => {
    const hasSeenPopup = localStorage.getItem("hasSeenSpecficPopup");

    if (!hasSeenPopup) {

      setSpecificModal(true);
      localStorage.setItem("hasSeenSpecficPopup", "true");
    }

    if (place && !hasSeenPopup) {
      setSpecificModal(true);
    }

    // Save a timestamp when the user navigates away
    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        localStorage.setItem("lastSeen", Date.now());
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [place]);


  return (
    <Fragment>
      <Helmet>
        <title>Find Exclusive Deals for your destination - MySittiVacations</title>
        <meta name="description" content="Looking for the best travel deals? Find exclusive offers for your destination with our expert guide. Discover amazing discounts on flights, hotels, and activities to help you save big on your next trip."></meta>
      </Helmet>
      <BannerSec />
      <div
        className="itemBox"
        style={{ marginTop: "10px", marginBottom: "10px" }}
      >
        <div className="offer-section">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                <div className="header-sec">
                  <h2>Offers for you</h2>
                  <ul>
                    <li className={dealsTabActive === "All" ? "activeMenu" : ""}>
                      <Link to={place ? `/deals/${place}` : "/deals"} className="nav-link dealsIconss" onClick={() => setDealsTabActive("All")} >
                        <img src={
                          dealsTabActive === "All"
                            ? "/images/allinclusicActive-icon.png"
                            : "/images/allinclusic-icon.png"
                        } alt="allinclusic-icon" />
                        All Inclusive
                      </Link>
                    </li>
                    <li className={dealsTabActive === "flights" ? "activeMenu" : ""}>
                      <Link to={place ? `/deals/flights/${place}` : "/deals"} className="nav-link dealsIconss" onClick={(e) => {
                        // always set the tab active
                        setDealsTabActive("flights");

                        if (!place) {
                          // prevent navigation
                          e.preventDefault();
                          // show toast
                          toast.error("Please select a city");
                        }
                      }} >
                        <img src={
                          dealsTabActive === "flights"
                            ? "/images/flightActive-icon.png"
                            : "/images/flight-icon.png"
                        } alt="flight-icon" />
                        Flights
                      </Link>
                    </li>
                    <li className={dealsTabActive === "hotels" ? "activeMenu" : ""}>
                      <Link to={place ? `/deals/hotels/${place}` : "/deals"} className="nav-link dealsIconss" onClick={(e) => {
                        setDealsTabActive("hotels")
                        if (!place) {
                          // prevent navigation
                          e.preventDefault();
                          // show toast
                          toast.error("Please select a city");
                        }
                      }}  >
                        <img src={
                          dealsTabActive === "hotels"
                            ? "/images/hotelActive-icon.png"
                            : "/images/hotel-icon.png"
                        } alt="hotel-icon" />
                        Hotels
                      </Link>
                    </li>
                    <li className={dealsTabActive === "vacations" ? "activeMenu" : ""}>
                      <Link to={place ? `/deals/vacations/${place}` : "/deals"} className="nav-link dealsIconss" onClick={(e) => {
                        setDealsTabActive("vacations")
                        if (!place) {
                          // prevent navigation
                          e.preventDefault();
                          // show toast
                          toast.error("Please select a city");
                        }
                      }}>
                        <img src={
                          dealsTabActive === "vacations"
                            ? "/images/vacationActive-icon.png"
                            : "/images/vacation-icon.png"
                        } alt="vacation-icon" />
                        Vacations
                      </Link>
                    </li>
                    <li className={dealsTabActive === "tours" ? "activeMenu" : ""}>
                      <Link to={place ? `/deals/tours/${place}` : "/deals"} className="nav-link dealsIconss" onClick={(e) => {
                        setDealsTabActive("tours")
                        if (!place) {
                          // prevent navigation
                          e.preventDefault();
                          // show toast
                          toast.error("Please select a city");
                        }
                      }}>
                        <img src={
                          dealsTabActive === "tours"
                            ? "/images/tourActive-icon.png"
                            : "/images/tour-icon.png"
                        } alt="tour-icon" />
                        Tours
                      </Link>
                    </li>
                    <li className={dealsTabActive === "cruises" ? "activeMenu" : ""}>
                      <Link to={place ? `/deals/cruises/${place}` : "/deals"} className="nav-link dealsIconss" onClick={(e) => {
                        setDealsTabActive("cruises")
                        if (!place) {
                          // prevent navigation
                          e.preventDefault();
                          // show toast
                          toast.error("Please select a city");
                        }
                      }}>
                        <img src={
                          dealsTabActive === "cruises"
                            ? "/images/curizeActive-icon.png"
                            : "/images/curize-icon.png"
                        } alt="curize-icon" />
                        Cruises
                      </Link>
                    </li>
                    <li className={dealsTabActive === "adventures" ? "activeMenu" : ""}>
                      <Link to={place ? `/deals/adventures/${place}` : "/deals"} className="nav-link dealsIconss" onClick={(e) => {
                        setDealsTabActive("adventures")
                        if (!place) {
                          // prevent navigation
                          e.preventDefault();
                          // show toast
                          toast.error("Please select a city");
                        }
                      }}>
                        <img src={
                          dealsTabActive === "adventures"
                            ? "/images/advantureActive-icon.png"
                            : "/images/advanture-icon.png"
                        } alt="advanture-icon" />
                        Adventures
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              {!loader ?

                <div className="flight-sec exitment-sec tour-slider">
                  <div className="slider-sec">
                    <div className="slider-main slider-section discount-section stay-sec comn-div">
                      <div className="container">
                        <div className="row">
                          <div className="col-12 col-md-12 col-lg-12">
                            {dealsData.length > 0 && <OwlCarousel {...settings1}>
                              {Array.isArray(dealsData) && dealsData.map((ele) => {
                                if (!ele) return null;
                                const title = typeof ele?.title === 'string' ? ele.title : '';
                                let price = '';
                                if (typeof ele?.price === 'string') {
                                  price = ele.price.replace('USD', '').trim();
                                } else if (typeof ele?.price === 'number') {
                                  price = ele.price;
                                }
                                return (
                                  <div
                                    data-aos="zoom-in-right"
                                    className="slider-block"
                                    key={ele?.id}
                                  >
                                    <a href={ele?.link} target="_blank" rel="noopener noreferrer">
                                      <div className="cities">
                                        <img loading="lazy" src={ele?.image_link} alt="deals" />
                                        <div className="slider-content">
                                          <div className="slider-content-inner">
                                            <h3>
                                              {title.length >= 15
                                                ? `${title.slice(0, 15)}...`
                                                : title}
                                            </h3>
                                            {/* <p>{ele?.description}</p> */}
                                          </div>
                                        </div>
                                        <div className="discount-action hotels purple-bg city-price">
                                          <div className="review-sec">
                                            <p>
                                              <span>$ {price}</span>
                                            </p>
                                            <a className="siti-btn">
                                              Book Now
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                );
                              })}
                            </OwlCarousel>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                :
                <div style={{ marginTop: "60vh" }}>
                  <DataLoader />
                </div>
              }

              <div data-aos="zoom-in-right" id="singleData">
              </div>
              <div className="view-tag clickable d-flex justify-content-center align-items-center">
                {loadMoreLoader ? (
                  <DataLoader />
                ) : (
                  <button type="button" ref={BtnMore} onClick={handleSeeAllClick} className='m-4 siti-btn' aria-label="See All">
                    See All
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <>
        <Modal
          show={seeMoreModal}
          onHide={() => setSeeMoreModal(false)}
          // backdrop="static"
          size="xl"
          className='modal_xl see-pop'
          keyboard={false}
        >
          <Modal.Header closeButton>
          </Modal.Header>
          <Modal.Body id="InclusiveScript">
            {!inclusiveScript && (
              <div className="text-center text-danger font-weight-bold p-4">
                Data Not Found
              </div>
            )}
          </Modal.Body>
        </Modal>
      </>
      <>
        {specificModal && (
          <SpcificPageModal
            specificModal={specificModal}
            setSpecificModal={setSpecificModal}
          />
        )}
      </>

    </Fragment>
  );
}
export default Deals;